import { configureStore } from '@reduxjs/toolkit';
// import featureNameReducer from '../features/featureName/featureNameSlice';
import userLoginInfo from '../features/UserInfo/userSlice.js'
export const store = configureStore({
    reducer: {
        user_info: userLoginInfo,
    },
});